<app-header></app-header>
<app-loader *ngIf="isPageLoaded" isAlertDialog="true"></app-loader>

<div class="wrapper">
  <app-loader *ngIf="isButtonLoader" isAlertDialog="true"></app-loader>

  <app-estimate-box *ngIf="!historyState?.isPaymentDone && !hidePlanSelection" [isLoader]="isLoader" [showBack]="false"
    [showForward]="false" [submitBtnLabel]="'Choose Plan'"
    (submitBtnClick)="saveBasicListingDetails('skip')"></app-estimate-box>

  <app-estimate-tab-box *ngIf="historyState?.isPaymentDone && !hidePlanSelection" [isLoader]="isLoader"
    (saveBtnClick)="saveBasicListingDetails('save&wait')" (closeBtnClick)="close()"></app-estimate-tab-box>

  <app-estimate-box
    *ngIf="hidePlanSelection && (historyState?.completedIndex != 1.1 && historyState?.completedIndex != 1.7)"
    [isLoader]="isLoader" [showBack]="false" [showForward]="false" [submitBtnLabel]="'Submit Listing'"
    (submitBtnClick)="saveBasicListingDetails('skipPlan')"></app-estimate-box>

  <app-estimate-tab-box
    *ngIf="hidePlanSelection && (historyState?.completedIndex == 1.1 || historyState?.completedIndex == 1.7)"
    [isLoader]="isLoader" (saveBtnClick)="saveBasicListingDetails('save&wait')"
    (closeBtnClick)="close()"></app-estimate-tab-box>

  <div class="section_wrapper mt-20">

    <div class=" basic_details dashBoard">
      <!-- stepper component -->

      <app-stepper currentIndex="1.1" class="stepper"
        *ngIf="!historyState?.isPaymentDone && !hidePlanSelection "></app-stepper>

      <app-stepper-save class="stepper-sell" [tabToSelect]="'Listing Details'" (tabBtnClick)="switchTab($event)"
        *ngIf="historyState?.isPaymentDone && !hidePlanSelection "></app-stepper-save>

      <app-stepper currentIndex="1.1" class="stepper"
        *ngIf="hidePlanSelection && (historyState?.completedIndex != 1.1 && historyState?.completedIndex != 1.7)"></app-stepper>

      <app-stepper-save class="stepper-sell" [tabToSelect]="'Listing Details'" (tabBtnClick)="switchTab($event)"
        *ngIf="hidePlanSelection && (historyState?.completedIndex == 1.1 || historyState?.completedIndex == 1.7)"></app-stepper-save>

      <div>
        <app-dynamic-form *ngIf="formConfig" [formConfig]="formConfig" (formValueChanged)="onFormValueChanged($event)"
          (formControlTouched)="onFormControlTouched($event)">
        </app-dynamic-form>

        <br>
        <app-green-button-v2
          *ngIf="isScreenWidthLarge && !historyState?.isPaymentDone && !isLoader && !hidePlanSelection && !hideContinue"
          [buttonType]="'submit'" (click)="saveBasicListingDetails('skip')" class="create_button" label="Choose Plan"
          [width]="'200px'" [height]="'47px'">
        </app-green-button-v2>

        <app-green-button-v2
          *ngIf="isScreenWidthLarge && historyState?.isPaymentDone && !isLoader && !hidePlanSelection"
          [buttonType]="'submit'" (click)="saveBasicListingDetails('save&wait')" class="create_button" label="Save"
          [width]="'200px'" [height]="'47px'">
        </app-green-button-v2>

        <app-green-button-v2
          *ngIf="isScreenWidthLarge &&  !isLoader && hidePlanSelection && (historyState?.completedIndex != 1.1 && historyState?.completedIndex != 1.7)"
          [buttonType]="'submit'" (click)="saveBasicListingDetails('skipPlan')" class="create_button"
          label="Submit Listing" [width]="'200px'" [height]="'47px'">
        </app-green-button-v2>

        <app-green-button-v2
          *ngIf="isScreenWidthLarge  && !isLoader && hidePlanSelection && (historyState?.completedIndex == 1.1 || historyState?.completedIndex == 1.7)"
          [buttonType]="'submit'" (click)="saveBasicListingDetails('save&wait')" class="create_button" label="Save"
          [width]="'200px'" [height]="'47px'">
        </app-green-button-v2>
      </div>

    </div>
  </div>
</div>


<ng-template #confirmationDialog>
  <div class="addGroupWrap">
    <div matDialogTitle>
      <span class="dialog-title">Confirm</span>
      <button mat-icon-button class="close-icon" (click)="closeDialog('close')">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div mat-dialog-content class="pt-2">
      <div>
        Do you like to move without saving the changes?
      </div>
    </div>
    <mat-dialog-actions>
      <div class="w-100 text-right">
        <button mat-button type="button" class="outlineBtn ml-1" (click)="closeDialog(closeFlag)"> Close </button>
        <button class="ml-1 submitBtn" type="submit" cdkFocusInitial mat-flat-button color="primary"
          (click)="saveBasicListingDetails(saveFlag)">
          Save
        </button>
      </div>
    </mat-dialog-actions>
  </div>
</ng-template>